<ng-container class="accountblock">
  <form [formGroup]="formRank">
    <div class="card m-6">
      <h5 class="card-header">Rank Information <span class="legend-label">{{requiredLegend}}</span></h5>
      <div class="card-body">
        <div class="form-group row">

          <div class="form-group row">
            <label for="projectType" class="col-sm-3 p-1 col-form-label-textbox-center">Project Type</label>
            <div class="col-sm-4 p-1">
              <select class="form-select" id="projectType" formControlName="projectTypeID" (change)="changeProjectType($event)">
                <option value="">Select Project Type</option>
                @for (projectType of projectTypes; track projectType) {
                  <option [value]="projectType.projectTypeID">
                    {{projectType.name}}
                  </option>
                }
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label for="investmentType" class="col-sm-3 p-1 col-form-label-textbox-center">Investment Type *</label>
            <div class="col-sm-4 p-1">
              <select class="form-select" id="investmentType" formControlName="investmentTypeID" (change)="changeinvestmentType($event)">
                <option value="">Select Investment Type</option>
                @for (investmentType of investmentTypes; track investmentType) {
                  <option [value]="investmentType.investmentTypeID">
                    {{investmentType.name}}
                  </option>
                }
              </select>
              @if (((formRank.get('investmentTypeID')?.touched) && formRank.get('investmentTypeID')?.errors?.required)) {
                <small class="invalid"
                  >Investment Type
                is mandatory</small>
              }
            </div>
          </div>

          <div class="form-group row">
            <label for="rank" class="col-sm-3 p-1 col-form-label-textbox-center">Rank</label>
            <div class="col-sm-4 p-1">
              <select class="form-select" id="rank" formControlName="rankID" (change)="changeRank($event)">
                <option value="">Select Rank</option>
                @for (rank of ranks; track rank) {
                  <option [value]="rank.rankID">
                    {{rank.name}}
                  </option>
                }
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label for="rankDecisionTiming" class="col-sm-3 p-1 col-form-label-textbox-center">Rank Decision Timing</label>
            <div class="col-sm-4 p-1" >
              <mat-form-field appearance="outline" style="font-size: .4em;">
                <input matInput formControlName="rankDecisionTiming" [matDatepicker]="rankDecisionTimingPicker" id="rankDecisionTiming"
                  style="height: 37px; font-size: .9rem; font-family:inherit; " (dateChange)="changeRankDecisionTiming($event)">
                  <mat-datepicker #rankDecisionTimingPicker></mat-datepicker>
                </mat-form-field>

                <mat-datepicker-toggle matSuffix [for]="rankDecisionTimingPicker">
                  <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
                </mat-datepicker-toggle>
              </div>
            </div>

            <div class="form-group row">
              <label for="rankDifficulty" class="col-sm-3 p-1 col-form-label-textbox-center">Difficulty Ranking</label>
              <div class="col-sm-4 p-1">
                <select class="form-select" id="rankDifficulty" formControlName="rankDifficultyID" (change)="changeRankDifficulty($event)">
                  <option value="">Select Difficulty Rank</option>
                  @for (rankDifficulty of rankDifficulties; track rankDifficulty) {
                    <option [value]="rankDifficulty.rankDifficultyID">
                      {{rankDifficulty.name}}
                    </option>
                  }
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label for="rankChangeDescription" class="col-sm-3 p-1 col-form-label-textbox-center">Ranking Change Description</label>
              <div class="col-sm-4 p-1">
                <textarea rows="3" class="form-control" class="form-control" formControlName="rankChangeDescription" id="rankChangeDescription"
                placeholder="Ranking Change Description" (input)="changeRankChangeDescription($event)">  </textarea>
                <!-- <small class="invalid"
                *ngIf="fourthFormGroup.get('rankChangeDescription')?.errors?.['maxlength']">Ranking Change Description maximum length is 2000 characters
              </small>        -->
            </div>
          </div>
          <div class="form-group row">
            <label for="milestoneImplemented" class="col-sm-3 p-1 col-form-label-textbox-center">Milestone Implemented</label>
            <div class="col-sm-4 p-1">
              <select class="form-select" id="milestoneImplemented" formControlName="milestoneImplementedID" (change)="changeMilestoneImplemented($event)">
                <option value="">Select Milestone Implemented</option>
                @for (milestoneImplemented of milestonesImplemented; track milestoneImplemented) {
                  <option [value]="milestoneImplemented.milestoneImplementedID">
                    {{milestoneImplemented.name}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
